import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { useSite, scrollToId } from "../lib/site";
import { SERVICE_KEYS, SERVICE_IMAGES } from "../content";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7"];

const ServiceCard = ({ k, i }) => {
  const { t, setService } = useSite();
  const s = t.services.items[k];
  const enquire = () => { setService(k); scrollToId("contact"); };
  return (
    <Reveal delay={(i % 2) * 0.1} className={`${SPANS[i]} h-full`}>
      <motion.article
        whileHover="hover"
        className="group relative h-full min-h-[440px] overflow-hidden rounded-2xl border border-[var(--line)] bg-[var(--ink-2)] p-7 sm:p-10 flex flex-col justify-between transition-[border-color] duration-500 hover:border-[var(--line-gold)]"
        data-testid={`service-card-${k}`}
      >
        <motion.img
          src={SERVICE_IMAGES[k]}
          alt=""
          variants={{ hover: { scale: 1.06, opacity: 0.38 } }}
          initial={{ scale: 1, opacity: 0.22 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 h-full w-full object-cover grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14] via-[#0B0E14]/85 to-[#0B0E14]/40" />
        <div className="relative flex items-start justify-between">
          <span className="f-mono text-sm text-[var(--gold)]">0{i + 1}</span>
          <span className="f-mono text-[11px] uppercase tracking-[0.25em] text-[var(--muted)]">Stravion</span>
        </div>
        <div className="relative mt-16">
          <h3 className="f-display text-3xl sm:text-4xl text-[var(--paper)]">{s.title}</h3>
          <p className="mt-4 max-w-md text-[var(--muted)] leading-relaxed">{s.text}</p>
          <ul className="mt-6 flex flex-wrap gap-2">
            {s.points.map((p) => (
              <li key={p} className="inline-flex items-center gap-2 rounded-full border border-[var(--line)] bg-[#0B0E14]/60 px-3 py-1.5 text-xs text-[var(--sand)]">
                <Check className="w-3 h-3 text-[var(--gold)]" />{p}
              </li>
            ))}
          </ul>
          <button onClick={enquire} data-testid={`service-enquire-${k}`} className="mt-8 inline-flex items-center gap-2 text-sm text-[var(--paper)] border-b border-[var(--gold)] pb-1 hover:text-[var(--gold)] transition-colors">
            {t.services.enquire} <ArrowUpRight className="w-4 h-4 rtl:-scale-x-100" />
          </button>
        </div>
      </motion.article>
    </Reveal>
  );
};

export const Services = () => {
  const { t } = useSite();
  return (
    <section id="services" className="py-24 lg:py-36" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead id="services" eyebrow={t.services.eyebrow} title={t.services.title} />
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-6 auto-rows-fr">
          {SERVICE_KEYS.map((k, i) => <ServiceCard key={k} k={k} i={i} />)}
        </div>
      </div>
    </section>
  );
};
